import { useLocalReactionStore, useSyncLocalStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import React, { FunctionComponent } from "react";
import { createProofingStore } from "../ProofService";
import { ProofingStoreContext } from "./ProofingStore";
import ProofOperationDialog, { ProofOperationDialogProps } from "./ProofOperationDialog";

const ProofOperationWrapper: FunctionComponent<ProofOperationDialogProps> = (props) => {
	const loc = useLocale();
	const { isEditOperation } = props;
	const store = useLocalReactionStore(() => {
		const doc = props.actionController.getNode();
		return createProofingStore(doc, loc, isEditOperation);
	});
	return (
		<ProofingStoreContext.Provider value={store}>
			{store &&
				<ProofOperationDialog {...props} />
			}
		</ProofingStoreContext.Provider>
	);
};
export default ProofOperationWrapper;